import { ListItemText, Stack, Typography } from "@mui/material";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatTime } from "~/modules/app/util/formatters";
import ObservationStatus from "~/modules/mapEditor/components/ObservationStatus/ObservationStatus";
import RenderIf from "~/shared/components/RenderIf";

import { ProjectReviewVisitV2ObservationListItemFragment } from "./fragments.generated";

type Props = {
    observation: ProjectReviewVisitV2ObservationListItemFragment;
};

export function ProjectReviewVisitV2ObservationListItem({ observation }: Props) {
    return (
        <Stack direction="row" alignItems="center" width="1">
            <ListItemText>
                <Typography variant="body2">{formatTime(parseStringToDate(observation.createdAt))}</Typography>
                <Typography>{observation.species.name}</Typography>
            </ListItemText>
            <RenderIf payload={observation.status} render={status => <ObservationStatus status={status} />} />
        </Stack>
    );
}
